import Vue from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag";

import "@/assets/scss/main.scss";
import "@/assets/scss/SpeakingIndex.scss";

Vue.config.productionTip = false


Vue.use(VueGtag, {
    config: { id: "UA-136510434-1" },
    includes: [
        { id: 'AW-608742370' },
    ]
});


import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
    'zh-Hant': {
        element_header: require('@/locales/element_header_zh-hant.json'),
        element_footer: require('@/locales/element_footer_zh-hant.json'),
        element_speaking: require('@/locales/element_speaking_zh-hant.json'),
    },
    'zh-Hans': {
      element_header: require('@/locales/element_header_zh-hans.json'),
      element_footer: require('@/locales/element_footer_zh-hans.json'),
      element_speaking: require('@/locales/element_speaking_zh-hans.json'),
    },
    'vi-VN': {
        element_header: require('@/locales/element_header_vi-VN.json'),
        element_footer: require('@/locales/element_footer_vi-VN.json'),
        element_privacy: require('@/locales/element_privacy_vi-VN.json')
    },
};

const i18n = new VueI18n({
    locale: 'zh-Hant', // set locale
    messages, // set locale messages
});

new Vue({
    i18n,
    render: h => h(App),
}).$mount('#app')